import { IVariant } from '../model/IVariants';
import { GetModelTrimLevel_trimLevelModels } from '../../trimLevels/graphql/queries/__generated__/GetModelTrimLevel';
import { GetSimpleSpecPackTrimLevel_specPacks } from '../../trimLevels/graphql/queries/__generated__/GetSimpleSpecPackTrimLevel';

const variantDataExtractor = {
  getVariantByVariantId: (variants: IVariant[], variantId: string) => {
    return variants?.find(item => item.variant.code === variantId);
  },
  getModelByVariantId: (models: GetModelTrimLevel_trimLevelModels[], variantId: string) => {
    return models?.find(item => item.model.code === variantId);
  },
  getSpecPackByVariantId: (specPacks: GetSimpleSpecPackTrimLevel_specPacks[], variantId: string) => {
    return specPacks?.find(item => item.specPack.code === variantId);
  },
};

export default variantDataExtractor;
